import { useTranslation } from "react-i18next";
import { sendMessage } from "utils/webview";
import useIsInappWebview from "hooks/useIsInappWebview";
import ButtonWithOptionalModal from "./ButtonWithOptionalModal";
import { useState } from "react";

export default function RequestStoreReviewButton({
  disabled,
}: {
  disabled: boolean;
}) {
  const { t: t_ui } = useTranslation("translation", {
    keyPrefix: "ui",
  });

  const isInappWebview = useIsInappWebview();
  const [isOpen, setIsOpen] = useState<boolean>(false);

  return (
    <ButtonWithOptionalModal
      startDecorator={undefined}
      disabled={disabled}
      openModal={!isInappWebview && isOpen}
      onClick={() => {
        if (isInappWebview) {
          sendMessage(
            JSON.stringify({
              event: "open_review",
            })
          );
        } else {
          setIsOpen(true);
        }
      }}
      onClose={() => {
        setIsOpen(false);
      }}
      buttonText={t_ui("리뷰 남기기")}
      title={"모바일 기기에서 진행해주세요"}
      actionText={"확인"}
    />
  );
}